import React from "react";
import PropTypes from "prop-types";

// Components
import { Link, graphql } from "gatsby";
import styled from 'styled-components';
import Layout from '../components/layout';

const Tags = ({ pageContext, data }) => {
  const { tag } = pageContext;
  const { edges, totalCount } = data.allMarkdownRemark;
  const tagHeader = `${totalCount} post${
    totalCount === 1 ? "" : "s"
  } tagged with "${tag}"`;

  return (
    <Layout>
      <div style={{marginBottom: '32px'}}>
        <h1>{tagHeader}</h1>
        {edges.map(({ node }, i) => {
          const { slug } = node.fields;
          const { title } = node.frontmatter;
          return (
            <TagLink key={i}>
              <Link to={slug}>{title}</Link>
            </TagLink>
          );
        })}
        <TagLink>
          <Link to="/tags">All tags</Link>
        </TagLink>
      </div>
    </Layout>
  );
};

Tags.propTypes = {
  pageContext: PropTypes.shape({
    tag: PropTypes.string.isRequired,
  }),
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            frontmatter: PropTypes.shape({
              title: PropTypes.string.isRequired,
            }),
            fields: PropTypes.shape({
              slug: PropTypes.string.isRequired,
            }),
          }),
        }).isRequired
      ),
    }),
  }),
};

export default Tags;

export const pageQuery = graphql`
  query($tag: String) {
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
  }
`


const TagLink = styled.div`
  margin: 4px 0px;
  > a {
    transition: color 0.15s ease-out;
    color: rgba(27, 28, 37, 0.7);
    :hover {
      color: rgba(27, 28, 37, 0.9);
    }
  }
`;
